// src/components/ArticleCard.js
import React from 'react';
import { Link } from 'react-router-dom';

function ArticleCard({ article, index = 0 }) {
  const generatedImages = ['/images/article_gen.png', '/images/article_gen_v1.png', '/images/article_gen_v3.jpeg', '/images/article_gen_v4.png', '/images/article_gen_v5.png', '/images/article_gen_v6.png'];
  const fallbackImage = generatedImages[index % generatedImages.length];
  const image = article.image || fallbackImage;

  return (
    <div className="article-card group min-h-[300px] focus-glow rounded-3xl p-4 -m-4">
      {/* Article Image */}
      <div className="relative aspect-[16/10] rounded-2xl overflow-hidden border border-white/5 mb-6">
        <img
          src={image}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-all duration-500"
        />
        {article.category && (
          <div className="absolute top-3 left-3 bg-brand/80 text-[#050805] px-2 py-0.5 rounded text-[8px] font-bold uppercase tracking-widest">
            {article.category}
          </div>
        )}
      </div>

      <div className="flex justify-between items-start mb-4">
        <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
          {new Date(article.created_at).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          })}
        </span>
        {article.calculator_name && (
          <div className="flex items-center gap-2 px-3 py-1 rounded-full bg-brand/10 border border-brand/30 text-brand font-bold text-[8px] tracking-widest uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-brand animate-pulse"></span>
            COMPUTE READY
          </div>
        )}
      </div>

      <h3 className="text-lg font-bold text-white mb-4 group-hover:text-brand transition-colors duration-300 leading-tight line-clamp-2">
        {article.title}
      </h3>

      <Link
        to={`/articles/${article.slug}`}
        className="mt-auto inline-flex items-center gap-2 text-brand font-bold text-[10px] tracking-[0.2em] group/link transition-all focus:outline-none uppercase"
      >
        READ ARTICLE
        <span className="material-symbols-outlined text-sm group-hover/link:translate-x-1 transition-transform">arrow_forward</span>
      </Link>
    </div>
  );
}
export default ArticleCard;
